import { render, staticRenderFns } from "./table-dri-breadcrumbs.vue?vue&type=template&id=4a658911&scoped=true&"
import script from "./table-dri-breadcrumbs.vue?vue&type=script&lang=js&"
export * from "./table-dri-breadcrumbs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a658911",
  null
  
)

export default component.exports